import { getJson, postJson } from '../../../shared/api/client';

export async function fetchCopilotConfig() {
  return getJson('/copilot/config');
}

export async function fetchCopilotThreads() {
  return getJson('/copilot/threads');
}

export async function createCopilotThread(payload) {
  return postJson('/copilot/threads', payload);
}

export async function fetchCopilotThread(threadId) {
  return getJson(`/copilot/threads/${threadId}`);
}

export async function createCopilotMessage(threadId, payload) {
  return postJson(`/copilot/threads/${threadId}/messages`, payload);
}

export async function fetchCopilotRun(runId) {
  return getJson(`/copilot/runs/${runId}`);
}

export async function approveCopilotRun(runId, payload) {
  return postJson(`/copilot/runs/${runId}/approve`, payload);
}
